import React, { useEffect, useState } from "react";
import { dashboardIcon } from "../../assets/img";
import DateRange from "../DateRange/DateRange";
import DateRange1 from "../DateRange/DateRange1";
import Select from "react-select";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";

function Bookings() {
  const [state, setState] = useState();
  const [locationList, setLocationsList] = useState({ cities: [] });

  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  const getLocationsList = async () => {
    let url = `${URLS.LOCATION}?type=3`;
    const res = await get(url);

    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => ({
        value: item?.id,
        label: item?.name,
      }));

      setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  useEffect(() => {
    getLocationsList();
  }, []);

  const [isData, setIsData] = useState({});
  const { paginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path] ?? { from: "" }
  );

  const getTopCard = async () => {
    let url = URLS.DASHBOARBOOKING_CARD;
    const params = [];

    if (selectedFilter.from) {
      params.push(
        `from_date=${new Date(selectedFilter.from).toLocaleDateString("en-CA")}`
      );
    }

    if (state?.value) {
      params.push(`city_id=${state?.value}`);
    }

    if (params.length > 0) url += `?${params.join("&")}`;

    try {
      let res = await get(url);
      if (res?.status === "success") {
        setIsData(res?.data ?? {});
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };

  useEffect(() => {
    getTopCard();
  }, [selectedFilter.from, state]);

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // smaller shadow
        borderRadius: "8px", // smaller
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#222227",
            width: "120px", // slightly smaller width
            margin: 0,
          }}
        >
          Bookings
        </p>
      </div>

      {/* Filters */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "8px", // smaller
        }}
      >
        <DateRange1 setFromDate={(date) => handleChangeFilter("from", date)} />

        <Select
          className="location-searchs"
          options={locationList?.cities}
          value={state}
          onChange={setState}
          placeholder={"All City"}
        />
      </div>

      <div
        style={{
          border: "1px solid #EEEEEE",
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "16px", // smaller
          padding: "14px 20px", // smaller
          marginTop: "14px", // smaller
        }}
      >
        <div>
          <p
            style={{
              fontSize: "16px", // smaller
              fontWeight: "400",
              color: "#9ca3af",
              margin: 0,
            }}
          >
            Total Bookings
          </p>
          <p
            style={{
              fontSize: "22px", // smaller
              fontWeight: "bold",
              color: "#000000",
              margin: 0,
            }}
          >
            {isData?.total_bookings && (isData?.total_bookings || 0).toFixed(2)}
          </p>
        </div>

        <div style={{ width: "26px", height: "26px" }}>
          {" "}
          {/* smaller */}
          <img
            src={dashboardIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      {/* Total SECTION */}
      <p
        style={{
          marginTop: "8px",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        {[
          { label: "Check In", value: isData?.check_in },
          { label: "Check Out", value: isData?.check_out },
          { label: "Cancelled", value: isData?.cancelled },
          { label: "Hold", value: isData?.hold },
          {
            label: "Total Upcoming",
            value: isData?.total_upcoming,
          },
        ].map((item, i) => (
          <div
            key={i}
            style={{
              background: "#F5F5F5",
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 10px", // smaller
              width: "48%",
              borderRadius: "8px", // smaller
              marginBottom: "12px", // smaller
            }}
          >
            <p style={styles.label}>{item.label}</p>
            <p style={styles.value}>
              {item.value && (item.value || 0).toFixed(2)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Bookings;
